export const ContractorDetailsMutations = {
  SetLoading: 'setLoading',
  SetAssignmentsLoading: 'setAssignmentsLoading',
  RetrieveContractorSuccess: 'retrieveContractorSuccess',
  SaveContractorSuccess: 'saveContractorSuccess',
  ResetContractorState: 'resetContractorState',
  SetContractorValidationErrors: 'setContractorValidationErrors',
  SetContractorAssignmentSortOrder: 'setContractorAssignmentsSortOrders',
  SetContractorAssignments: 'setContractorAssignments',
  SetContractorHistories: 'setContractorHistories',
  RetrieveContractorAttachmentsSuccess: 'retrieveContractorAttachmentsSuccess',
  SetContractorDepositSlips: 'setContractorDepositSlips'
};

export const ContractorDetailsActions = {
  RetrieveContractor: 'retrieveContractor',
  SaveContractor: 'saveContractor',
  ResetCurrentContractor: 'resetCurrentContractor',
  UpdateContractorValidationErrors: 'updateContractorValidationErrors',
  SetContractorAssignmentsSortOrder: 'updateAssignmentSortOrder',
  RetrieveContractorAssignemnts: 'retrieveContractorAssignments',
  RetrieveContractorHistories: 'retrieveContractorHistories',
  RetrieveContractorAttachments: 'retrieveContractorAttachments',
  RetrieveContractorDepositSlips: 'retrieveContractorDepositSlips'
};

export const ContractorDetailsGetters = {
  IsAssignmentsLoading: 'isAssignmentsLoading',
  CurrentContractor: 'CurrentContractor',
  CurrentContractorAssignments: 'getContractorAssignments',
  ContractorAssignmentsSortOrder: 'getContractorAssignmentSortOrder',
  CurrentContractorHistories: 'getContractorHistories',
  SelectedHistoryRecord: 'getSelectedHistory',
  CurrentContractorAttachments: 'getContractorAttachments',
  ContractorValidationErrors: 'getContractorValidationErrors',
  CurrentContractorDepositSlips: 'getCurrentContractorDepositSlips'
};
